<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-audiobook`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43.421 19.961a21.143 21.143 0 01-.645 3.416l-3.856-1.065c.249-.9.424-1.825.523-2.769a17.023 17.023 0 00-.12-4.487 16.99 16.99 0 00-3.872-8.345L38.49 4.11a20.989 20.989 0 014.783 10.312c.292 1.817.344 3.676.148 5.54zm-35.8 15.342a9 9 0 0017.902 1.882l.036.003c.182-1.739 1.962-4.56 5.388-8.23a13.965 13.965 0 005.513-9.728C37.268 11.54 31.69 4.65 24 3.843c-7.69-.808-14.579 4.77-15.387 12.46l3.978.418c.578-5.493 5.498-9.477 10.99-8.9 5.493.577 9.478 5.498 8.9 10.99a9.967 9.967 0 01-4.05 7.033l-.15.11-.128.136c-4.062 4.326-6.27 7.806-6.572 10.68l-.036-.004a5 5 0 01-9.945-1.045l-3.978-.418zm22.767-15.706a8 8 0 00-14.43-5.539 7.816 7.816 0 00-.07-.007l-.013.123a7.964 7.964 0 00-1.4 3.75l.995.105a4 4 0 11-.836 7.956l-.418 3.978a8 8 0 005.698-14.31 4 4 0 016.496 3.526l3.978.418z"/></svg>
</template>
<script>

export default {
  name: 'IconAudiobook',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
